import packageOverviewRedux from 'Modules/packages/views/overview/redux/reducer';
import packagesFeatureTabRedux from 'Modules/packages/.components/featureTab/redux/reducer';
import createEditPackageRedux from 'Modules/packages/.components/createEditPackage/redux/reducer';
import deletePackageRedux from 'Modules/packages/.components/deletePackage/redux/reducer';
import assignedToTabRedux from 'Modules/packages/.components/assignedToTab/redux/reducer';

//export redux objects
export default {
	packageOverviewRedux,
	packagesFeatureTabRedux,
	createEditPackageRedux,
	deletePackageRedux,
	assignedToTabRedux,
};